__webpack_require__.p = "https://fe-static-test.hkgai.org/meeting-ai-fe-web/18511/";